const ContainerBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#333" d="M0 0h24v24H0z" />
    <path fill="#ffd400" d="M2 2h20v20H2z" />
    <path fill="#333" d="M4 4h16v16H4z" />
  </svg>
);

export default ContainerBlockIcon;
